"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FileDetails;

var _immutable = require("immutable");

var _ActionTypes = require("../actions/ActionTypes");

var _Constants = require("../Constants");

var _FoldersAndFiles = require("../utils/FoldersAndFiles");

var defaultState = (0, _immutable.Map)({
  fileDetails: (0, _immutable.Map)(),
  fetchRequestsById: (0, _immutable.Map)(),
  uploadRequestsById: (0, _immutable.OrderedMap)()
});

function replaceFile(state, file) {
  if (file && file.get('id')) {
    return state.setIn(['fileDetails', file.get('id')], file);
  }

  return state;
}

function mergeFiles(state, files) {
  return state.update('fileDetails', function (fileDetails) {
    return fileDetails.merge((0, _FoldersAndFiles.toOrderedMap)(files));
  });
}

function deleteFileIds(state, fileIds) {
  fileIds.forEach(function (id) {
    state = state.deleteIn(['fileDetails', id]);
  });
  return state;
}

function updateFileName(state, file) {
  if (state.getIn(['fileDetails', file.get('id')])) {
    return state.setIn(['fileDetails', file.get('id'), 'name'], file.get('name'));
  }

  return state;
}

function FileDetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      fileId = action.fileId,
      file = action.file,
      progress = action.progress,
      data = action.data;
  var existingFile = state.get('fileDetails').get(fileId);
  var timestamp = new Date().getTime();

  switch (type) {
    case _ActionTypes.FETCH_SINGLE_FILE_ATTEMPTED:
      return state.mergeIn(['fetchRequestsById', fileId], {
        status: _Constants.RequestStatus.PENDING
      });

    case _ActionTypes.FETCH_SINGLE_FILE_FAILED:
      return state.mergeIn(['fetchRequestsById', fileId], {
        status: _Constants.RequestStatus.FAILED
      });

    case _ActionTypes.FETCH_SINGLE_FILE_SUCCESS:
      return state.setIn(['fileDetails', fileId], file).mergeIn(['fetchRequestsById', fileId], {
        status: _Constants.RequestStatus.SUCCEEDED
      });

    case _ActionTypes.UPLOAD_FILE_SUCCEEDED:
      return state.setIn(['fileDetails', file.get('id')], file).mergeIn(['uploadRequestsById', file.get('id')], {
        status: _Constants.RequestStatus.SUCCEEDED,
        timestamp: timestamp
      });

    case _ActionTypes.CREATE_VIDYARD_PLAYERID_SUCCEEDED:
    case _ActionTypes.SOFT_DELETE_VIDYARD_PLAYERID_SUCCEEDED:
    case _ActionTypes.REPLACE_FILE_SUCCEEDED:
    case _ActionTypes.CHANGE_FILE_ACCESSIBILITY_REQUEST_SUCCEEDED:
    case _ActionTypes.REPLACE_FILE_FAILED:
    case _ActionTypes.REMOVE_CANVA_ID_SUCCEEDED:
    case _ActionTypes.UPLOAD_EDITED_IMAGE_SUCCEEDED:
    case _ActionTypes.VIDEO_THUMBNAIL_UPDATE_SUCCEEDED:
    case _ActionTypes.GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_SUCCEEDED:
    case _ActionTypes.SAVE_EDIT_SUCCEEDED:
    case _ActionTypes.RECALCULATE_IMAGE_DIMENSIONS_SUCCESS:
      return replaceFile(state, file);

    case _ActionTypes.MOVE_FILE_SUCCEEDED:
    case _ActionTypes.ARCHIVE_FILE_SUCCEEDED:
    case _ActionTypes.UNARCHIVE_FILE_SUCCEEDED:
    case _ActionTypes.RENAME_FILE_SUCCEEDED:
      return replaceFile(state, data);

    case _ActionTypes.RENAME_FILE_ATTEMPTED:
    case _ActionTypes.RENAME_FILE_FAILED:
      return updateFileName(state, data);

    case _ActionTypes.ACQUIRE_IMAGE_SUCCEEDED:
      state = replaceFile(state, data);
      return state.mergeIn(['uploadRequestsById', data.get('id')], {
        status: _Constants.RequestStatus.SUCCEEDED,
        timestamp: timestamp
      });

    case _ActionTypes.REPLACE_FILE_ATTEMPTED:
      if (existingFile) {
        return replaceFile(state, existingFile.merge(Object.assign({
          replaced: true,
          size: action.tempFile.size,
          tempUrl: action.tempUrl,
          progress: progress
        }, action.dimensions)));
      }

      return state;

    case _ActionTypes.REPLACE_FILE_PROGRESS:
      if (existingFile) {
        return replaceFile(state, existingFile.merge({
          progress: progress
        }));
      }

      return state;

    case _ActionTypes.BULK_MOVE_ATTEMPTED:
      return deleteFileIds(state, action.files.map(function (f) {
        return f.get('id');
      }));

    case _ActionTypes.BULK_MOVE_SUCCEEDED:
      if (action.updatedFiles) {
        return mergeFiles(state, action.updatedFiles);
      }

      return state;

    case _ActionTypes.DELETE_FILE_SUCCEEDED:
      return deleteFileIds(state, [fileId]);

    case _ActionTypes.BULK_DELETE_SUCCEEDED:
      return deleteFileIds(state, action.files.map(function (f) {
        return f.get('id');
      }));

    case _ActionTypes.DOWNLOAD_FROM_EXTERNAL_URL_ATTEMPTED:
      return state.set('downloadFromExternalUrlStatus', _Constants.RequestStatus.PENDING);

    case _ActionTypes.DOWNLOAD_FROM_EXTERNAL_URL_SUCCEEDED:
      state = replaceFile(state, file);
      state = state.mergeIn(['uploadRequestsById', file.get('id')], {
        status: _Constants.RequestStatus.SUCCEEDED,
        timestamp: timestamp
      });
      return state.set('downloadFromExternalUrlStatus', _Constants.RequestStatus.SUCCEEDED);

    default:
      return state;
  }
}

module.exports = exports.default;